export default __webpack_public_path__ + "ca1dcfda5c64bc4a82a8e4f5e6644eec.png";